<script setup lang="ts">
import StripeSubscriptionBrowser from '~components/admin/StripeSubscriptionBrowser.vue'
import SelfLink from '~components/widgets/SelfLink.vue'
</script>

<template>
  <b-container fluid>
    <h1><self-link href="/admin/orders/stripe">Stripe Subscriptions</self-link></h1>
    <hr>
    <stripe-subscription-browser />
  </b-container>
</template>
